import { useControlledSliderWithOpenRange, useValueFilter } from '@/scopes/search/search/domain/hooks'
import { Chip } from '@sunwebgroup/ui-components'
import { useCallback } from 'react'

export function PricePerPersonChips() {
  const { isFetching, isLoading, resetFilterValues, selectedValue, setSelection } = useValueFilter('PricePerPerson')
  const { labelProps } = useControlledSliderWithOpenRange(selectedValue, setSelection)

  const handleRemoveClick = useCallback(() => {
    // This function is needed, as setting the value to undefined will throw an error from the mappper
    resetFilterValues('PricePerPerson')
  }, [resetFilterValues])

  if (isLoading)
    return null
  if (!selectedValue)
    return null

  return (
    <Chip value={selectedValue.toString()} disabled={isFetching} removable onRemoveClick={handleRemoveClick}>
      {labelProps.formattedRange}
    </Chip>
  )
}
